/** @generated */
// cspell:disable

/** @typedef {import('axios').AxiosInstance} AxiosInstance */

import { SweetPath } from 'sweet-path';

/**
 * @typedef {import('./settings-get-entities-count-action-body').SettingsGetEntitiesCountActionBody} SettingsGetEntitiesCountActionBody
 */

/**
 * @typedef {import('./settings-get-entities-count-action-response').SettingsGetEntitiesCountActionResponse} SettingsGetEntitiesCountActionResponse
 */

/**
 * The path of the SettingsGetEntitiesCountAction action.
 */
export const settingsGetEntitiesCountActionPath = new SweetPath('/api/user/settings/entities_count', {
  path: '{param}',
});

/**
 * Creates a contextualized SettingsGetEntitiesCountAction action.
 *
 * @param {AxiosInstance} axios
 */
export default function createSettingsGetEntitiesCountAction(axios) {
  /**
   * The settingsGetEntitiesCountAction action.
   *
   * @param { { headers: Object<string,string>,parameters: Object<string,string|number|boolean>,query: {limit?: number; offset?: number; filter?: Object<string,string|number|boolean>;, sort?: {by: string; order: string;}} } }
   *
   * @returns {Promise<SettingsGetEntitiesCountActionResponse>}
   */
  function settingsGetEntitiesCountAction({ headers = {}, parameters = {}, query = {} } = {}) {
    const path = settingsGetEntitiesCountActionPath.insert(parameters);

    return axios.get(path, { params: query, headers });
  }

  return settingsGetEntitiesCountAction;
}
